/* ==========================================================================
   Header: mobile drawer, sticky shadow, search drawer
   ========================================================================== */
(function () {
  'use strict';

  var mobileDrawer = document.getElementById('MobileMenuDrawer');
  var searchDrawer = document.getElementById('SearchDrawer');

  /* ---- Mobile drawer ---- */
  function openMobileDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.setAttribute('aria-hidden', 'false');
    theme.lockScroll();
    theme.lockFocusTrap(mobileDrawer.querySelector('.mobile-drawer__panel'));
    var toggle = document.querySelector('[data-mobile-drawer-open]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeMobileDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.setAttribute('aria-hidden', 'true');
    theme.unlockScroll();
    theme.releaseFocusTrap();
    var toggle = document.querySelector('[data-mobile-drawer-open]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
    document.querySelectorAll('[data-mobile-submenu]').forEach(function (panel) {
      panel.classList.remove('is-active');
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mobile-drawer-open]')) {
      openMobileDrawer();
    } else if (event.target.closest('[data-mobile-drawer-close]')) {
      closeMobileDrawer();
    } else if (event.target.closest('[data-mobile-submenu-open]')) {
      var index = event.target.closest('[data-mobile-submenu-open]').getAttribute('data-mobile-submenu-open');
      var panel = document.getElementById('MobileSubmenu-' + index);
      if (panel) panel.classList.add('is-active');
    } else if (event.target.closest('[data-mobile-submenu-back]')) {
      var active = event.target.closest('[data-mobile-submenu]');
      if (active) active.classList.remove('is-active');
    }
  });

  /* ---- Search drawer ---- */
  function openSearchDrawer() {
    if (!searchDrawer) return;
    searchDrawer.setAttribute('aria-hidden', 'false');
    theme.lockScroll();
    var input = searchDrawer.querySelector('[data-predictive-search-input]');
    theme.lockFocusTrap(searchDrawer.querySelector('.search-drawer__panel'), input);
  }

  function closeSearchDrawer() {
    if (!searchDrawer) return;
    searchDrawer.setAttribute('aria-hidden', 'true');
    theme.unlockScroll();
    theme.releaseFocusTrap();
    var toggle = document.querySelector('[data-search-open]');
    if (toggle) toggle.focus();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-search-open]')) {
      openSearchDrawer();
    } else if (event.target.closest('[data-search-close]')) {
      closeSearchDrawer();
    }
  });

  document.addEventListener('theme:escape', function () {
    if (mobileDrawer && mobileDrawer.getAttribute('aria-hidden') === 'false') closeMobileDrawer();
    if (searchDrawer && searchDrawer.getAttribute('aria-hidden') === 'false') closeSearchDrawer();
  });

  /* ---- Sticky header shadow on scroll ---- */
  var header = document.querySelector('[data-header]');
  if (header && header.dataset.sticky === 'true') {
    var lastScroll = 0;
    window.addEventListener(
      'scroll',
      theme.debounce(function () {
        var current = window.scrollY;
        header.classList.toggle('is-scrolled', current > 10);
        lastScroll = current;
      }, 10)
    );
  }

  /* ---- Size guide modal ---- */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-size-guide-open]')) {
      event.preventDefault();
      var modal = document.querySelector('[data-size-guide-modal]');
      if (modal) {
        modal.setAttribute('aria-hidden', 'false');
        theme.lockScroll();
        theme.lockFocusTrap(modal.querySelector('.modal__panel'));
      }
    } else if (event.target.closest('[data-size-guide-close]')) {
      var openModal = document.querySelector('[data-size-guide-modal][aria-hidden="false"]');
      if (openModal) {
        openModal.setAttribute('aria-hidden', 'true');
        theme.unlockScroll();
        theme.releaseFocusTrap();
      }
    }
  });
})();
